// @flow
import React from 'react';
import { Link } from 'gatsby';
import { connect } from 'react-redux';

import { updatePairs as updateUIPairs } from '../../redux/ui';

import * as styles from './Steps.module.scss';

const Steps = ({
  merchantType,
  contactVisited,
  businessVisited,
  confirmVisited,
  bankVisited,
  _updateUIPairs,
}: {
  merchantType: string,
  contactVisited: string,
  businessVisited: string,
  confirmVisited: string,
  bankVisited: string,
  _updateUIPairs: Function,
}) => {
  const onNav = event => {
    switch (event.currentTarget.getAttribute('data-to')) {
      case '/basic-business': {
        _updateUIPairs({ isFromConfirm: false });

        break;
      }
      case '/basic-personal': {
        _updateUIPairs({ isFromConfirm: false });

        break;
      }
      case '/confirm': {
        if (!confirmVisited) {
          event.preventDefault();
        } else {
          _updateUIPairs({ isFromConfirm: false });
        }

        break;
      }
      case '/contact': {
        if (!contactVisited) {
          event.preventDefault();
        } else {
          _updateUIPairs({ isFromConfirm: false });
        }

        break;
      }
      case '/bank': {
        if (!bankVisited) {
          event.preventDefault();
        } else {
          _updateUIPairs({ isFromConfirm: false });
        }

        break;
      }
      case '/business': {
        if (!businessVisited) {
          event.preventDefault();
        } else {
          _updateUIPairs({ isFromConfirm: false });
        }

        break;
      }
      default: {
        break;
      }
    }
  };

  return (
    <div className={styles.navWrapper}>
      <nav className={styles.steps}>
        {merchantType === 'personal' && (
          <Link
            to="/basic-personal"
            data-to="/basic-personal"
            onClick={onNav}
            className={styles.step}
            activeClassName={styles.active}
          >
            <span>担当者情報 / 個人事業主</span>
          </Link>
        )}
        {merchantType === 'business' && (
          <Link
            to="/basic-business"
            data-to="/basic-business"
            onClick={onNav}
            className={styles.step}
            activeClassName={styles.active}
          >
            <span>担当者情報 / 法人</span>
          </Link>
        )}
        <Link
          to="/business"
          onClick={onNav}
          data-to="/business"
          className={styles.step}
          activeClassName={styles.active}
        >
          <span>事業内容</span>
        </Link>
        <Link
          to="/bank"
          onClick={onNav}
          data-to="/bank"
          className={styles.step}
          activeClassName={styles.active}
        >
          <span>金融機関</span>
        </Link>
        <Link
          to="/confirm"
          onClick={onNav}
          data-to="/confirm"
          className={styles.step}
          activeClassName={styles.active}
        >
          <span>お申込み内容のご確認</span>
        </Link>
      </nav>
    </div>
  );
};

const mapStateToProps = state => ({
  ...state.contact,
  merchantType: state.uiToBeCached.merchantType,
  businessVisited: state.ui.businessVisited,
  bankVisited: state.ui.bankVisited,
  contactVisited: state.ui.contactVisited,
  confirmVisited: state.ui.confirmVisited,
});

const mapDispatchToProps = (dispatch: Function) => ({
  _updateUIPairs: pairs => dispatch(updateUIPairs(pairs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Steps);
